import mutations from './mutations';
import { DataService } from '../../../config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [], 
    loading: false, 
    error: null
});

const actions = {
    async taskReadAll({ commit }, query) {
        try {
            commit('taskReadAllBegin');
            const response = await DataService.get(`/tasks?${new URLSearchParams(query).toString()}`);
            commit('taskReadAllSuccess', response.data.data);
        } catch (err) {
            commit('taskReadAllError', err);
        }
    },

    async taskAdd({ commit }, data) {
        try {
            commit('taskAddBegin');
            const response = await DataService.post('/tasks', data);
            commit('taskAddSuccess', response.data.data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            commit('taskAddError', err);
        }
    },

    async taskUpdate({ commit }, data) {
        try {
            commit('taskUpdateBegin');
            const response = await DataService.put(`/tasks/${data.id}`, data);
            commit('taskUpdateSuccess', response.data.data);

            notification.success({
                message: response.data.message,
                placement: 'topRight'
            });
        } catch (err) {
            commit('taskUpdateError', err);
        }
    },

    async onTaskStarUpdate({
        commit
    }, {data, id}) {

        try {
            commit('starUpdateBegin');

            data.map((item) => {
                if (item.id === id) {
                    const fav = item;
                    if (fav.favourite) {
                        item.favourite = false;
                    } else {
                        fav.favourite = true;
                    }
                }
            });

            return commit('starUpdateSuccess', data);
        } catch (err) {
            commit('starUpdateErr', err);
        }
    },

    async onCompleteUpdate({
        commit
    }, {data, id}) {
        try {
            commit('completeUpdateBegin');
            data.map((item) => {
                if (item.id === id) {
                    const complete = item;
                    if (complete.completed) {
                        item.completed = false;
                    } else {
                        complete.completed = true;
                    }
                }
            });
            return commit('completeUpdateSuccess', data);
        } catch (err) {
            commit('completeUpdateErr', err);
        }
    },

    async ontaskDelete({
        commit
    }, data) {
        try {
            commit('taskReadBegin');
            commit('taskReadSuccess', data);
        } catch (err) {
            commit('taskReadErr', err);
        }
    },

    async ontaskEdit({
        commit
    }, data) {
        try {
            commit('taskReadBegin');
            commit('taskReadSuccess', data);
        } catch (err) {
            commit('taskReadErr', err);
        }
    }
};

export default {
    namespaced: false,
    state,
    actions,
    mutations
};
